import httpClient from "@/services/base.service.js";

export default {
  delete: function (id) {
    return httpClient.delete("/api/v1/projectsearch/delete/" + id);
  },
  getAll: function () {
    return httpClient.get("/api/v1/projectsearch/get");
  },
  getById: function (id) {
    return httpClient.get("/api/v1/projectsearch/get/" + id);
  },
  save: function (params) {
    return httpClient.post('/api/v1/projectsearch/post', params)
  }
};
